<div class="list" #list>
  <div class="list-wrap" #listWrap>
    <header-list
      [listElem]="listWrap"
      [activeSortType]="collection?.getParams('sort')"
      [activeSortValue]="collection?.getParams('sort')"
      [sortItems]="fields"
      [stickyOptions]="stickyOptions"
      (clickSortItem)="filtersChanged($event)"
      (fieldsChanged)="fieldsWidthChanged.next(true)">
    </header-list>

    <div
      class="containerWrapper"
      infinite-scroll
      #scrollContainer
      [infiniteScrollContainer]="element"
      [fromRoot]="true"
      [infiniteScrollDistance]="30"
      [infiniteScrollUpDistance]="2"
      [infiniteScrollThrottle]="300"
      (scrolled)="onScroll()">
      <div
        #heightContainer
        id="heightContainer"
        style="
              height:{{ totalContentHeight }};
              position: relative;
              will-change: transform;
            ">
        <div
          class="result-list"
          style="
                transform: translateY({{ offsetY }}px);
              ">
          <template #rowContainer></template>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noSet>
  <span class="no-set__value">
    {{ 'No set' | translate }}
  </span>
</ng-template>
